import React from 'react'
import { EmailCapture, Header } from './Header'
import { observer } from 'mobx-react-lite'
import List from './List'

const ListContainer = observer(
	({ data, category, backgroundColor, allData }, ref) => {

		return (
			<div ref={ref}>
				
				<EmailCapture category={category} data={allData} />
				

				<Header category={category} backgroundColor={backgroundColor}  />
				<List category={category} data={data} />

				<style jsx>{`
					div {
						padding-top: 130px;
					}
				`}</style>
			</div>
		)
	},
	{ forwardRef: true }
)

export default ListContainer
